import { useLocation } from 'react-router-dom';
import { useLayoutEffect } from 'react';

const ScrollToTop = () => {
    const { hash, pathname } = useLocation();

    useLayoutEffect(() => {
        if (hash) {
            const frameId = window.requestAnimationFrame(() => {
                document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: 'instant', block: 'start' });
            });
            return () => window.cancelAnimationFrame(frameId);
        }

        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
        return undefined;
    }, [hash, pathname]);

    return null;
}

export default ScrollToTop;
